import {isProductionEnv} from '../utils/processHelpers';

export const WINDOW_PREFIX = 'osLaunchpad';

export const ADMIN_WINDOW = `${WINDOW_PREFIX}Admin`;
export const CHANNELS_WINDOW = `${WINDOW_PREFIX}Channels`;
export const LOGIN_WINDOW = `${WINDOW_PREFIX}Login`;
export const SNAPSHOT_WINDOW = `${WINDOW_PREFIX}Snapshot`;
export const SNAPSHOT_OVERLAY_WINDOW = `${WINDOW_PREFIX}SnapshotOverlay`;
export const PREVIEW_WINDOW = `${WINDOW_PREFIX}Preview`;

const isProduction = isProductionEnv();

export const adminWindows = {
    admin: {
        alwaysOnTop: true,
        autoShow: false,
        contextMenu: !isProduction,
        defaultCentered: true,
        defaultHeight: 500,
        defaultWidth: 700,
        id: ADMIN_WINDOW,
        frame: false,
        maxHeight: -1,
        maximizable: false,
        minHeight: 500,
        minWidth: 620,
        minimizable: true,
        name: ADMIN_WINDOW,
        resizable: true,
        saveWindowState: false,
        shadow: true,
        showTaskbarIcon: true,
        url: '/admin.html',
        waitForPageLoad: false
    }
};

const config = {
    ...adminWindows
};

export default config;
